export const REMEMBER_ME = "rememberMe";
